import React from 'react';
import { useNavigate } from 'react-router-dom';
import HamburgerMenuIcon from './HamburgerMenuIcon.jsx';
import { Button } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Header = ({ isSmallScreen, isSidebarOpen, toggleSidebar, onSignOut }) => {
    const navigate = useNavigate();

    const handleSignOut = () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('userRole');
        localStorage.removeItem('token');
        onSignOut();
        navigate('/');
    };

    return (
        <header className="title-container">
            {isSmallScreen && <HamburgerMenuIcon isOpen={isSidebarOpen} toggleMenu={toggleSidebar} />}
            <h1 className="dashboard-title">Dashboard</h1>
            <Button 
                onClick={handleSignOut}
                className="logout-btn d-flex align-items-center  py-1 mx-1"
            >
                <i className="bi bi-box-arrow-right"></i>
                <span>Log Out</span>
            </Button>
        </header>
    );
};

export default Header;